import axios from "axios";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { routeErrorHandler } from "Helper/routerErrorHandler";
import { toast } from "react-toastify";
import { getAppConfig } from "../services/configService";

export let API = null;
export let AccountsAPI = null;
export let ReportsAPI = null;
export let DocumentAPI = null;
export let CompanyAPI = null;

const STORAGE_KEYS = {
  CASE_API: "caseApiUrl",
  ACCOUNTS_API: "accountsApiUrl",
  REPORTS_API: "reportsApiUrl",
  DOCUMENT_API: "documentApiUrl",
  COMPANY_API: "companyApiUrl",
};

export let TOKEN = ``;
export let baseURL = localStorage.getItem(STORAGE_KEYS.CASE_API);
export let CaseAPI = localStorage.getItem(STORAGE_KEYS.CASE_API);
export let ReportURL = localStorage.getItem(STORAGE_KEYS.REPORTS_API);
export let AccountsURL = localStorage.getItem(STORAGE_KEYS.ACCOUNTS_API);

export const TokenHandler = () => {
  const { accessToken } = useOidcAccessToken();
  TOKEN = "Bearer " + accessToken;
  return;
};

const authUrl = (path = "") => {
  const { authServerUrl } = getAppConfig();
  return new URL(path, authServerUrl.replace(/\/+$/, "") + "/").toString();
};

const createAxiosInstance = (baseURL) => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use((req) => {
    if (TOKEN) {
      req.headers.Authorization = TOKEN;
    }
    return req;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      if (status === 460) {
        const userMessage = error.response?.data?.userMessage;
        if (userMessage) {
          import("../store") // lazy import to avoid circular deps
            .then(({ default: store }) => {
              const { showErrorDialog } = require("../reducers/errorDialogSlice");
              store.dispatch(showErrorDialog(userMessage));
            });
          return Promise.reject(error);
        }
      }
      if (status === 403) {
        const apiMessage = error.response?.data?.error;
        if (apiMessage) toast.warn(`Not permitted: ${apiMessage}`);
        else toast.warn("Not permitted:");
      }
      const requestURL = error.config?.url;
      const customError = routeErrorHandler(requestURL, error);
      return Promise.reject(customError);
    }
  );

  return instance;
};

export const fetchAndSetBaseURLs = async () => {
  const userInfoUrl = authUrl("connect/userinfo");

  const response = await axios.get(userInfoUrl, {
    headers: { Authorization: TOKEN },
  });

  localStorage.setItem(STORAGE_KEYS.CASE_API, response.data.CaseAPIUrl);
  localStorage.setItem(STORAGE_KEYS.ACCOUNTS_API, response.data.AccountsAPIUrl);
  localStorage.setItem(STORAGE_KEYS.REPORTS_API, response.data.ReportsAPIUrl);
  localStorage.setItem(STORAGE_KEYS.DOCUMENT_API, response.data.DocumentAPIUrl);
  localStorage.setItem(STORAGE_KEYS.COMPANY_API, response.data.CompanyAPIUrl);

  baseURL = response.data.CaseAPIUrl;
  CaseAPI = response.data.CaseAPIUrl;
  ReportURL = response.data.ReportsAPIUrl;
  AccountsURL = response.data.AccountsAPIUrl;

  if (!API) {
    API = createAxiosInstance(localStorage.getItem(STORAGE_KEYS.CASE_API));
    AccountsAPI = createAxiosInstance(
      localStorage.getItem(STORAGE_KEYS.ACCOUNTS_API)
    );
    ReportsAPI = createAxiosInstance(
      localStorage.getItem(STORAGE_KEYS.REPORTS_API)
    );
    DocumentAPI = createAxiosInstance(
      localStorage.getItem(STORAGE_KEYS.DOCUMENT_API)
    );
    CompanyAPI = createAxiosInstance(
      localStorage.getItem(STORAGE_KEYS.COMPANY_API)
    );
  }

  return { API, AccountsAPI, ReportsAPI, DocumentAPI, CompanyAPI };
};

export const getAPIInstance = async () => {
  if (!API) {
    await fetchAndSetBaseURLs();
  }
  return API;
};
